/**
 * Create a webform that submits values to the webform-handler application. 
 * 
 * Required props: name. The name of the endpoint that the form should submit to. Must match the corresponding endpoint in the webform-handler application.
 * 
 * Supply the form fields as the children of the element.
 * 
 * Example usage: 
 * <webform name="library-contact">
 *     <label for="message">
 *          <span>How can we help you?</span>
 *          <textarea name="message" id="message" rows="5" required />
 *      </label>
 * </webform>
 * 
 * The webform component automatically includes:
 *  - A honeypot email confirmation field 
 *  - A field that contains the URL of the page
 *  - A recaptcha challenge
 *  - A submit button
 */
import React from 'react';
import { useEffect, useState } from 'react'; 
import PropTypes from 'prop-types'
import Swal from 'sweetalert2'

import ReCaptcha from "@pittica/gatsby-plugin-recaptcha"

import * as styles from 'src/uglib_styles/webform.module.css'
import { reset } from 'src/uglib_utils/forms';
 
function WebForm ({name, children}) {

    const [recaptcha_submitted, setRecaptchaSubmitted] = useState(false)
    const submit = (token) => {}

    useEffect(()  => {
        const notify = function (response, text) {
            if (response.ok) {
                Swal.fire({
                    iconHtml: '<span class="icon success fa fa-envelope"></span>',
                    html: text,
                    showCloseButton: true,
                    showCancelButton: false,
                    focusConfirm: false,
                    confirmButtonText:
                        '<span class="fa fa-thumbs-up"></span> OK',
                    confirmButtonAriaLabel: 'OK',
                    confirmButtonColor: '#c20430',
                });
            }

            else {
                Swal.fire({
                    iconHtml: '<span class="icon error fa-regular fa-circle-xmark"></span>',
                    html: text,
                    showCloseButton: true,
                    showCancelButton: false,
                    focusConfirm: false,
                    confirmButtonText:
                        'OK',
                    confirmButtonAriaLabel: 'OK',
                    confirmButtonColor: '#c20430',
                });
            }   
        }

        const submit_form = async function(event) {
            event.preventDefault();
            event.stopPropagation();

            const form = document.getElementById(name);
            const url = form.getAttribute('action');

            const response = await fetch(url, {
                method: 'POST',
                body: new FormData(event.target)
            });

            const result = await response.text();
            notify(response, result);

            if(response.ok) {
                reset(form);   
            }        
        }
        
        const form = document.getElementById(name);
        form.addEventListener('submit', submit_form);

        const url_input = form.querySelector('.submit_url');
        if(url_input !== null) {
            url_input.value = window.location;
        }

    }, [name]);

    let action = "https://webform.lib.uoguelph.ca/" + name

    return (<>
        <div className={styles.webform_wrapper}> 
            <form id={name} className="webform" method="post" action={action}>
                {children}                 
                    
                <label className="invisible hp" aria-hidden="true">
                    <span>Email Confirmation</span>
                    <input type="email" name="email_confirmation_hp" className="email_confirmation" autoComplete='off'/>
                </label>

                <input type="hidden" className="submit_url" name="submitted_at_url"></input>
                <ReCaptcha
                    action="webform"
                    siteKey="6LcWH_seAAAAAO8z_MqJA0V8xT5Fbv6DTq3TTXG2"
                    onVerify={(token) => submit(token)}
                    submitted={recaptcha_submitted}
                />
                <button className="btn btn-secondary" type="submit" onClick={() => setRecaptchaSubmitted(true)}>Submit</button>
            </form>

        </div>
    </>);
    
}

WebForm.propTypes = {
	name: PropTypes.string,
}
   
export default WebForm